import { FC, useState } from 'react';
import intl from 'react-intl-universal';
import { Modal, Typography } from '@getsynapse/design-system';
import Divider from 'Atoms/Divider';
import BusinessUnitForm from './BusinessUnitForm';
import ChangeToForm from './ChangeToForm';

interface ChangeTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (businessUnit: string) => void;
  isLoading: boolean;
}

const ChangeTypeModal: FC<ChangeTypeModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const [newBusinessUnit, setNewBusinessUnit] = useState<string>('');

  const actionButtons = [
    {
      children: intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.CONFIRM_BUTTON'
      ),
      onClick: () => onSubmit(newBusinessUnit),
      variant: 'primary',
      disabled: !newBusinessUnit || isLoading,
      loading: isLoading,
    },
    {
      children: intl.get('CANCEL'),
      onClick: onClose,
      variant: 'tertiary',
    },
  ];

  return (
    <Modal
      title={intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.TITLE'
      )}
      closeModal={onClose}
      isOpen={isOpen}
      size='medium'
      aria-label={intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.TITLE'
      )}
      titleIcon={{
        name: 'people',
        className: 'text-neutral text-xl',
      }}
      childrenClassName='max-h-112'
      actionButtons={actionButtons}
    >
      <div className='flex flex-col gap-6'>
        <ChangeToForm />
        <Typography variant='body'>
          {intl.getHTML(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.DESCRIPTION'
          )}
        </Typography>
        <Divider className='mt-0' />
        <Typography variant='body'>
          {intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.BUSINESS_UNIT_FORM.TITLE'
          )}
        </Typography>
        <BusinessUnitForm onChange={(value) => setNewBusinessUnit(value)} />
      </div>
    </Modal>
  );
};

export default ChangeTypeModal;
